import { useFormActions } from '../core';
import type { FieldState } from '../core';
import { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePreFilledFieldValidation = <Val = any>(
  field: FieldState<Val>,
  touched: boolean,
) => {
  const { setFieldTouched } = useFormActions();

  useEffect(() => {
    if (field.value && !touched) {
      (async () => {
        await setFieldTouched(field.name, true, true);
      })();
    }
  }, [field, setFieldTouched, touched]);
};
